var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('a',{staticClass:"color-primary",attrs:{"href":_vm.downloadApplicationUrl,"target":"_blank"}},[_vm._v(" Application No. "+_vm._s(`${_vm.variableSymbol} ${_vm.person.name}${_vm.person.surname}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }